import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css'],
})
export class ConfirmDialogComponent implements OnInit {
  progressBarPercentage = 100;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      cancelText: string;
      confirmText: string;
      message: string;
      title: string;
      warning: string;
      // countdownSeconds?: number | null;
      // countdownReturnValue?: number | null;
    },
    private mdDialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {}
  @HostListener('keydown.esc')
  public onEsc() {
    this.close(false);
  }

  ngOnInit() {
    // if (
    //   this.data.countdownSeconds !== null &&
    //   this.data.countdownSeconds !== undefined
    // ) {
    //  this.startCountdown(Math.round(this.data.countdownSeconds));
    // }
  }

  public cancel() {
    this.close(false);
  }
  public close(value: any) {
    this.mdDialogRef.close(value);
  }
  public confirm() {
    this.close(true);
  }

  // private async startCountdown(secondsLeft: number) {
  //   for (let i = 0, len = secondsLeft * 2; i <= len; i++) {
  //     await delay(500);
  //     if (len === i) {
  //       this.close(this.data.countdownReturnValue);
  //     }
  //     secondsLeft -= 0.5;
  //     if(this.data !== null && this.data !== undefined){
  //       this.progressBarPercentage =
  //         (secondsLeft / this.data.countdownSeconds) * 100;
  //     }
  //   }
  // }
}
